import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App, VhvVorbelegungdaten } from '@ps20-frontend/frontend-models';
import {
  VersicherungssummeForLinie,
  VersicherungssummenResponseReceived,
} from '../action-types/versicherungssummenResponseReceived';
import { VhvActions } from '../vhvActions';
import { IAppState } from '../appState';

export const versicherungssummenReducer = function (
  sectionState: VersicherungssummeForLinie[] = null,
  action: AnyAction,
  appState: IAppState,
): VersicherungssummeForLinie[] {
  switch (action.type) {
    case VhvActions.VERSICHERUNGSSUMMEN_RESPONSE_RECEIVED: {
      const changeAction: VersicherungssummenResponseReceived = action.payload;
      return changeAction.summen;
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: VhvVorbelegungdaten = action.payload;
      if (
        actionPayload.forApp === App.VHV &&
        actionPayload.angebotsId === appState.angebotsId &&
        actionPayload.versicherungssumme
      ) {
        return [
          {
            produktlinie: actionPayload.produktlinienname,
            summe: actionPayload.versicherungssumme,
          },
        ];
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
